import React from 'react';
import './Auth.css';

const SetNewPassword = () => {
  return (
    <div className="auth-container">
      <h2>Set a new password</h2>
      <p>Create a new password. Ensure it differs from previous ones for security.</p>
      <form className="auth-form">
        <input type="password" placeholder="Password" required />
        <input type="password" placeholder="Confirm Password" required />
        <button type="submit" className="auth-btn">Update Password</button>
      </form>
    </div>
  );
};

export default SetNewPassword; 